import styled from '@emotion/styled';
import { css_gap, css_if, css_letter, css_medium_up, css_text } from '~/emotion/theme';

const Tabs = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: ${css_gap('large')};
	margin-bottom: ${css_gap('section', 2)};
`;

const Tab = styled.button<{ active: boolean }>`
	border: none;
	border-bottom: 2px solid ${css_if('active', css_text(), 'transparent')};
	background: transparent;
	padding: 0 0 ${css_gap('grid', 2)};
	color: ${css_if('active', css_text(), css_text('weak'))};
	text-transform: uppercase;
	letter-spacing: ${css_letter('md')};
	font-size: 0.625rem;
	font-weight: 700;

	@media (${css_medium_up}) {
		font-size: 0.7rem;
	}
`;

interface BetaTabsProps<T> {
	active: number;
	items: T[];
	getLabel: (item: T, index: number) => string;
	onChange: (index: number) => void;
}

export default function BetaTabs<T>({ active, items, getLabel, onChange }: BetaTabsProps<T>) {
	if (items.length <= 1) {
		return null;
	}

	return (
		<Tabs>
			{items.map((item, index) => (
				<Tab key={index} type="button" active={index === active} onClick={() => onChange(index)}>
					{getLabel(item, index)}
				</Tab>
			))}
		</Tabs>
	);
}
